import {
  TOGGLE_COLLAPSE,
  SET_WHOLE_STATE,
  SET_MODE,
  SET_VALUE,
  SET_FROM_DATE,
  SET_TO_DATE,
  SET_COMPANY,
  SET_COMPANY_INPUT,
  RESET_FORM,
} from "./reducer"

export const toggleCollapse = () => ({
  type: TOGGLE_COLLAPSE,
  payload: null,
})
export const setWholeState = (searchParamGroup) => ({
  type: SET_WHOLE_STATE,
  payload: { searchParamGroup },
})
export const setMode = (mode) => ({
  type: SET_MODE,
  payload: { mode },
})
export const setValue = (name, value) => ({
  type: SET_VALUE,
  payload: { name, value },
})
export const setFromDate = (fromDate) => ({
  type: SET_FROM_DATE,
  payload: { fromDate },
})
export const setToDate = (toDate) => ({
  type: SET_TO_DATE,
  payload: { toDate },
})
export const setCompany = (company) => ({
  type: SET_COMPANY,
  payload: { company },
})
export const setCompanyInput = (companyInput) => ({
  type: SET_COMPANY_INPUT,
  payload: { companyInput },
})
export const resetForm = () => ({
  type: RESET_FORM,
  payload: null,
})
